import { Link } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import Breadcrumb from '@/components/feature/Breadcrumb';
import ScrollToTop from '@/components/feature/ScrollToTop';
import PageMeta from '@/components/feature/PageMeta';
import { OrganizationSchema, WebPageSchema, FAQSchema } from '@/components/feature/SchemaOrg';

export default function AboutPage() {
  const faqQuestions = [
    {
      question: '黑料bu是什么？',
      answer: '黑料bu是一个专注收录网络热点黑料的资讯聚合平台，我们第一时间汇聚明星、网红、大V的最新黑料动态，内容真实可查，更新及时。',
    },
    {
      question: '黑料bu的内容来源是哪里？',
      answer: '黑料bu的内容来源于网络公开信息、社交媒体爆料以及用户投稿。我们会对每一条信息进行多方核实，确保内容的真实性和客观性。',
    },
    {
      question: '如何向黑料bu投稿？',
      answer: '您可以通过本页面的联系表单向我们提交线索或爆料内容。我们的编辑团队会在24小时内审核您提交的信息，审核通过后将尽快发布。',
    },
    {
      question: '黑料bu的更新频率是怎样的？',
      answer: '黑料bu实行24小时滚动更新机制，我们的编辑团队全天候关注网络热点，确保您能在第一时间获取最新最热的黑料资讯。',
    },
    {
      question: '如果发现不实信息怎么办？',
      answer: '如您发现平台上的内容存在不实之处，请立即通过联系表单或邮件与我们取得联系。我们将在核实后第一时间进行处理，包括修正或下架相关内容。',
    },
  ];

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const form = e.currentTarget;
    const formData = new FormData(form);

    const honeypot = formData.get('phone_alt');
    if (honeypot && String(honeypot).trim() !== '') {
      const successMsg = document.getElementById('form-success');
      if (successMsg) successMsg.classList.remove('hidden');
      form.reset();
      return;
    }

    formData.delete('phone_alt');

    const params = new URLSearchParams();
    formData.forEach((value, key) => {
      params.append(key, String(value));
    });

    try {
      const response = await fetch('https://readdy.ai/api/form/d9qs2kfnahb7382ovelg', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: params.toString(),
      });
      const responseText = await response.text();
      let parsed;
      try { parsed = JSON.parse(responseText); } catch { parsed = null; }

      if (response.ok && parsed?.code === 'OK') {
        const successMsg = document.getElementById('form-success');
        if (successMsg) successMsg.classList.remove('hidden');
        const errorMsg = document.getElementById('form-error');
        if (errorMsg) errorMsg.classList.add('hidden');
        form.reset();
      } else {
        const errorMsg = document.getElementById('form-error');
        const errorText = document.getElementById('form-error-text');
        if (errorMsg) errorMsg.classList.remove('hidden');
        if (errorText) {
          errorText.textContent = parsed?.meta?.message || parsed?.message || '提交失败，请稍后重试';
        }
      }
    } catch {
      const errorMsg = document.getElementById('form-error');
      const errorText = document.getElementById('form-error-text');
      if (errorMsg) errorMsg.classList.remove('hidden');
      if (errorText) errorText.textContent = '网络错误，请稍后重试';
    }
  };

  return (
    <>
      <ScrollToTop />
      <PageMeta
        title="关于我们 - 黑料bu｜品牌介绍、口碑评价与联系方式"
        description="了解黑料bu品牌故事与发展历程，查看用户口碑评价。黑料bu是专注网络热点黑料的资讯聚合平台，致力于为用户提供真实、及时的黑料资讯服务。"
        keywords="黑料bu,关于黑料bu,黑料bu联系方式,黑料bu品牌,黑料bu口碑"
        canonicalUrl="https://heiliao.bu/about"
      />
      <OrganizationSchema
        name="黑料bu"
        url="https://heiliao.bu"
        description="黑料bu是专注收录网络热点黑料的资讯聚合平台，第一时间汇聚明星、网红、大V的最新黑料动态。"
      />
      <WebPageSchema
        name="关于我们 - 黑料bu"
        url="https://heiliao.bu/about"
        description="了解黑料bu品牌故事、口碑评价与联系方式。"
      />
      <FAQSchema questions={faqQuestions} />

      <Navbar />
      <Breadcrumb items={[
        { label: '首页', href: '/' },
        { label: '关于我们' },
      ]} />

      <main>
        <section className="w-full px-4 md:px-8 py-12 md:py-16">
          <div className="max-w-4xl mx-auto">
            <h1 className="text-2xl md:text-3xl lg:text-4xl font-bold font-heading text-foreground-950 mb-4">
              关于黑料bu
            </h1>
            <p className="text-base text-foreground-600 leading-relaxed mb-12">
              黑料bu是专注收录网络热点黑料的资讯聚合平台。我们致力于第一时间汇聚明星、网红、大V的最新黑料动态，为用户提供真实、及时、全面的黑料资讯服务。
            </p>

            <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 mb-16">
              <div>
                <h2 className="text-xl font-bold font-heading text-foreground-950 mb-4">品牌故事</h2>
                <div className="space-y-4 text-sm text-foreground-700 leading-relaxed">
                  <p>
                    在这个信息爆炸的时代，网络上充斥着各种真假难辨的信息。作为吃瓜群众的我们，常常在海量信息中迷失方向，不知道哪些是真实的、哪些是编造的。
                  </p>
                  <p>
                    正是基于这样的痛点，<strong>黑料bu</strong>应运而生。我们的创始团队由一群资深娱乐媒体人和技术专家组成，怀着"让每一条黑料都有据可查"的初心，打造了这样一个专业、严谨的黑料资讯聚合平台。
                  </p>
                  <p>
                    自上线以来，黑料bu始终坚持<strong>内容真实、更新及时</strong>的原则，通过多方信源交叉验证，确保每一条资讯都经得起推敲。我们不是八卦的制造者，而是真相的搬运工。
                  </p>
                  <p>
                    如今，黑料bu已经成长为国内领先的黑料资讯聚合平台，每日为数以万计的吃瓜群众提供最新、最热的黑料动态。我们持续优化产品体验，只为让你不错过任何一个热点瓜。
                  </p>
                </div>
              </div>

              <div className="bg-background-100 rounded-lg p-6 md:p-8">
                <h2 className="text-xl font-bold font-heading text-foreground-950 mb-6">平台数据</h2>
                <div className="grid grid-cols-2 gap-6">
                  <div className="text-center">
                    <div className="text-3xl font-bold text-accent-500 font-heading">10万+</div>
                    <div className="text-xs text-foreground-500 mt-1">日活跃用户</div>
                  </div>
                  <div className="text-center">
                    <div className="text-3xl font-bold text-accent-500 font-heading">100+</div>
                    <div className="text-xs text-foreground-500 mt-1">日均文章更新</div>
                  </div>
                  <div className="text-center">
                    <div className="text-3xl font-bold text-accent-500 font-heading">5</div>
                    <div className="text-xs text-foreground-500 mt-1">内容分类</div>
                  </div>
                  <div className="text-center">
                    <div className="text-3xl font-bold text-accent-500 font-heading">99.8%</div>
                    <div className="text-xs text-foreground-500 mt-1">内容准确率</div>
                  </div>
                </div>
              </div>
            </div>

            <div className="mb-16">
              <h2 className="text-xl font-bold font-heading text-foreground-950 mb-4">用户口碑</h2>
              <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
                <div className="bg-background-50 border border-background-200 rounded-lg p-5">
                  <div className="flex items-center gap-1 mb-3">
                    {[...Array(5)].map((_, i) => (
                      <i key={i} className="ri-star-fill text-sm text-accent-500"></i>
                    ))}
                  </div>
                  <p className="text-sm text-foreground-700 leading-relaxed mb-3">
                    "吃瓜这么多年，黑料bu是我见过最靠谱的平台。信息更新快，内容也经过核实，不像其他平台全是标题党。"
                  </p>
                  <div className="text-xs text-foreground-500 font-medium">—— 资深吃瓜群众 小A</div>
                </div>
                <div className="bg-background-50 border border-background-200 rounded-lg p-5">
                  <div className="flex items-center gap-1 mb-3">
                    {[...Array(5)].map((_, i) => (
                      <i key={i} className="ri-star-fill text-sm text-accent-500"></i>
                    ))}
                  </div>
                  <p className="text-sm text-foreground-700 leading-relaxed mb-3">
                    "分类做得很好，想看的明星、网红都能快速找到。每天上班第一件事就是刷黑料bu看有没有新瓜。"
                  </p>
                  <div className="text-xs text-foreground-500 font-medium">—— 娱乐行业从业者 大K</div>
                </div>
                <div className="bg-background-50 border border-background-200 rounded-lg p-5">
                  <div className="flex items-center gap-1 mb-3">
                    {[...Array(5)].map((_, i) => (
                      <i key={i} className="ri-star-fill text-sm text-accent-500"></i>
                    ))}
                  </div>
                  <p className="text-sm text-foreground-700 leading-relaxed mb-3">
                    "作为自媒体人，黑料bu是我获取选题素材的重要来源。内容质量高，时效性强，强烈推荐！"
                  </p>
                  <div className="text-xs text-foreground-500 font-medium">—— 自媒体博主 文案君</div>
                </div>
              </div>
            </div>

            <div className="mb-16">
              <h2 className="text-xl font-bold font-heading text-foreground-950 mb-4">常见问题</h2>
              <div className="space-y-3">
                {faqQuestions.map((faq, idx) => (
                  <details key={idx} className="group bg-background-50 border border-background-200 rounded-lg overflow-hidden">
                    <summary className="flex items-center justify-between p-4 cursor-pointer hover:bg-background-100 transition-colors">
                      <span className="text-sm font-medium text-foreground-800 pr-4">{faq.question}</span>
                      <i className="ri-arrow-down-s-line text-foreground-500 group-open:rotate-180 transition-transform flex-shrink-0"></i>
                    </summary>
                    <div className="px-4 pb-4 text-sm text-foreground-600 leading-relaxed">
                      {faq.answer}
                    </div>
                  </details>
                ))}
              </div>
            </div>

            <div id="contact" className="bg-background-100 rounded-lg p-6 md:p-8">
              <h2 className="text-xl font-bold font-heading text-foreground-950 mb-2">联系我们</h2>
              <p className="text-sm text-foreground-600 mb-6">
                如有任何问题、建议或爆料线索，欢迎通过以下方式联系我们。
              </p>

              <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
                <div>
                  <div className="space-y-4">
                    <div className="flex items-start gap-3">
                      <div className="w-10 h-10 rounded-lg bg-accent-100 flex items-center justify-center flex-shrink-0">
                        <i className="ri-mail-line text-accent-600"></i>
                      </div>
                      <div>
                        <h4 className="text-sm font-semibold text-foreground-950 mb-1">电子邮箱</h4>
                        <a href="mailto:contact@heiliao.bu" className="text-sm text-accent-500 hover:text-accent-600">
                          contact@heiliao.bu
                        </a>
                      </div>
                    </div>
                    <div className="flex items-start gap-3">
                      <div className="w-10 h-10 rounded-lg bg-accent-100 flex items-center justify-center flex-shrink-0">
                        <i className="ri-wechat-line text-accent-600"></i>
                      </div>
                      <div>
                        <h4 className="text-sm font-semibold text-foreground-950 mb-1">微信公众号</h4>
                        <span className="text-sm text-foreground-600">搜索关注：黑料bu官方</span>
                      </div>
                    </div>
                    <div className="flex items-start gap-3">
                      <div className="w-10 h-10 rounded-lg bg-accent-100 flex items-center justify-center flex-shrink-0">
                        <i className="ri-weibo-line text-accent-600"></i>
                      </div>
                      <div>
                        <h4 className="text-sm font-semibold text-foreground-950 mb-1">微博</h4>
                        <span className="text-sm text-foreground-600">@黑料bu官方微博</span>
                      </div>
                    </div>
                    <div className="flex items-start gap-3">
                      <div className="w-10 h-10 rounded-lg bg-accent-100 flex items-center justify-center flex-shrink-0">
                        <i className="ri-time-line text-accent-600"></i>
                      </div>
                      <div>
                        <h4 className="text-sm font-semibold text-foreground-950 mb-1">工作时间</h4>
                        <span className="text-sm text-foreground-600">周一至周日 9:00 - 24:00</span>
                      </div>
                    </div>
                  </div>
                </div>

                <div>
                  <form
                    id="contact-form"
                    data-readdy-form
                    action="https://readdy.ai/api/form/d9qs2kfnahb7382ovelg"
                    method="POST"
                    encType="application/x-www-form-urlencoded"
                    className="space-y-4"
                    onSubmit={handleSubmit}
                  >
                    <div>
                      <label htmlFor="contact-name" className="block text-sm font-medium text-foreground-700 mb-1">姓名</label>
                      <input
                        type="text"
                        id="contact-name"
                        name="name"
                        required
                        className="w-full px-3 py-2.5 bg-background-50 border border-background-300 rounded-md text-sm text-foreground-800 focus:outline-none focus:border-accent-500 transition-colors"
                        placeholder="请输入您的姓名"
                      />
                    </div>
                    <div>
                      <label htmlFor="contact-email" className="block text-sm font-medium text-foreground-700 mb-1">邮箱</label>
                      <input
                        type="email"
                        id="contact-email"
                        name="email"
                        required
                        className="w-full px-3 py-2.5 bg-background-50 border border-background-300 rounded-md text-sm text-foreground-800 focus:outline-none focus:border-accent-500 transition-colors"
                        placeholder="请输入您的邮箱"
                      />
                    </div>
                    <div>
                      <label htmlFor="contact-subject" className="block text-sm font-medium text-foreground-700 mb-1">主题</label>
                      <input
                        type="text"
                        id="contact-subject"
                        name="subject"
                        required
                        className="w-full px-3 py-2.5 bg-background-50 border border-background-300 rounded-md text-sm text-foreground-800 focus:outline-none focus:border-accent-500 transition-colors"
                        placeholder="请输入主题"
                      />
                    </div>
                    <div>
                      <label htmlFor="contact-message" className="block text-sm font-medium text-foreground-700 mb-1">留言内容</label>
                      <textarea
                        id="contact-message"
                        name="message"
                        required
                        rows={4}
                        maxLength={500}
                        className="w-full px-3 py-2.5 bg-background-50 border border-background-300 rounded-md text-sm text-foreground-800 focus:outline-none focus:border-accent-500 transition-colors resize-none"
                        placeholder="请输入您的留言（不超过500字）"
                      ></textarea>
                    </div>

                    <div className="honeypot-field">
                      <input
                        type="text"
                        name="phone_alt"
                        tabIndex={-1}
                        autoComplete="off"
                        aria-hidden="true"
                        readOnly
                      />
                    </div>

                    <div id="form-success" className="hidden bg-accent-100 border border-accent-300 rounded-md p-3 text-sm text-accent-800">
                      <i className="ri-check-line mr-1"></i> 提交成功！我们会尽快回复您。
                    </div>
                    <div id="form-error" className="hidden bg-accent-100 border border-accent-300 rounded-md p-3 text-sm text-accent-800">
                      <i className="ri-error-warning-line mr-1"></i>
                      <span id="form-error-text">提交失败，请稍后重试</span>
                    </div>

                    <button
                      type="submit"
                      className="w-full bg-accent-500 hover:bg-accent-600 text-background-50 px-6 py-2.5 rounded-md text-sm font-semibold transition-all duration-200 whitespace-nowrap cursor-pointer"
                    >
                      提交留言
                    </button>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </section>
      </main>

      <Footer />
    </>
  );
}